import { render, staticRenderFns } from "./BkashPromotionBanner.vue?vue&type=template&id=c6b99b64&scoped=true&"
import script from "./BkashPromotionBanner.vue?vue&type=script&lang=js&"
export * from "./BkashPromotionBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6b99b64",
  null
  
)

export default component.exports